export enum ShutdownReason {
    Flash = 1,
    NonLinear = 2,
    Skipped = 3,
    Complete = 4,
    Error = 5
}
